import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Check if the error is a ChunkLoadError
    if (error.name === 'ChunkLoadError' || (error.message && error.message.includes('Loading chunk'))) {
      console.warn("ChunkLoadError detected. The app may have been updated. Reloading the page...");
      // Force a hard reload from the server to get the new chunk hashes
      window.location.reload(true);
    }
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'sans-serif' }}>
          <h2>Oops! Un errore di caricamento.</h2>
          <p>Abbiamo rilasciato un aggiornamento e il tuo browser sta cercando una versione vecchia.</p>
          <p>Stiamo ricaricando la pagina automaticamente...</p>
          <button 
            onClick={() => window.location.reload(true)} 
            style={{ 
              padding: '10px 20px', 
              marginTop: '20px', 
              backgroundColor: '#4CAF50', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Ricarica Ora
          </button>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
